/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
import * as Blockly from 'blockly';
import { ModalField } from './modalField';
import {
  ROWS, COLS, emptyLeds, presetToLeds, PRESETS,
} from './matrix8x16Leds';
import './matrix8x16Modal.scss';

// Deben coincidir con el tamaño de las miniaturas en el SCSS: el paso de las flechas del cajón
// se calcula con ellos.
const PRESET_WIDTH = 100;
const PRESET_GAP = 10;

// El valor del campo es { leds: { 0..127: boolean } }, la forma que guarda prod, para que los
// proyectos viejos abran igual.
export class Matrix8x16Modal extends ModalField {
  name_ = 'Matrix8x16';

  // 175x165 es la vista senior (con la imagen del módulo); BHOOT_matrix_8x8_junior comparte este
  // campo con otra vista y otro tamaño, que se eligen según `config.junior`.
  blockWidth_ = 175;

  blockHeight_ = 165;

  constructor(value, validator, config) {
    super(value, validator, config);
    this.junior_ = !!(config && config.junior);
    if (this.junior_) {
      // 40x40 declarado a propósito, no la medida visual (52.8x54): el renderer suma el tamaño
      // declarado directo a la fila y el bloque quedaría más grande que en prod. El contenido
      // desborda con overflow:visible (ver matrix8x16Modal.scss).
      this.blockWidth_ = 40;
      this.blockHeight_ = 40;
    }
  }

  openDrawer_ = null;

  rulerOn_ = false;

  painting_ = false;

  // Lista aparte: disposeEvents() de la base también saca el handler del backdrop, que tiene que
  // sobrevivir a los cambios de drawer.
  drawerEvents_ = [];

  leds() {
    return (this.value_ && this.value_.leds) ? this.value_.leds : emptyLeds();
  }

  setLeds(leds) {
    // paintBlockContent y no refreshBlockContent: setValue ya dispara el evento de cambio.
    this.setValue({ ...this.value_, leds });
    this.paintBlockContent();
    this.paintGrid();
  }

  renderBlockContent_() {
    const leds = this.leds();
    let rows = '';
    for (let row = 0; row < ROWS; row += 1) {
      let cells = '';
      for (let col = 0; col < COLS; col += 1) {
        cells += `<div class="led ${leds[(row * COLS) + col] ? 'led-on' : ''}"></div>`;
      }
      rows += `<div class="led-row">${cells}</div>`;
    }
    const miniClass = this.junior_ ? 'matrix-mini-junior' : 'matrix-mini';
    return `<div class="${miniClass}"><div class="mini-leds">${rows}</div></div>`;
  }

  renderCells() {
    const leds = this.leds();
    let rows = '';
    for (let row = 0; row < ROWS; row += 1) {
      let cells = '';
      for (let col = 0; col < COLS; col += 1) {
        const index = (row * COLS) + col;
        cells += `<div class="led ${leds[index] ? 'led-on' : ''}" data-index="${index}" data-content="${col}"></div>`;
      }
      rows += `<div class="led-row" data-row="${row}" data-content="${row}">${cells}</div>`;
    }
    return rows;
  }

  renderPicker(drawer, title) {
    return `<span class="picker picker-${drawer}" data-drawer="${drawer}" title="${title}"></span>`;
  }

  renderDrawer() {
    if (!this.openDrawer_) return '';

    const items = Object.keys(PRESETS[this.openDrawer_])
      .map((n) => `<span class="preset preset-${this.openDrawer_}-${n}" data-preset="${n}"></span>`)
      .join('');

    return `<div class="drawer-scroller">${items}</div>`;
  }

  // Los glifos icon-* salen de la fuente de íconos que la app carga global en src/index.js.
  renderModalContent_() {
    return `
      <div class="matrix-close" title="Cerrar"><span class="icon-cross11"></span></div>
      <div class="matrix-box">
        <div class="matrix-grid">${this.renderCells()}</div>
      </div>
      <div class="matrix-sidebar">
        <div class="sidebar-panel">
          <span class="drawer-arrow prev" title="Anterior"></span>
          <div class="drawer-viewport"></div>
          <span class="drawer-arrow next" title="Siguiente"></span>
        </div>
        <div class="sidebar-buttons">
          ${this.renderPicker('emotions', 'Emociones')}
          ${this.renderPicker('icons', 'Iconos')}
          <span class="button ruler" title="Numerar filas y columnas"><span class="icon-grid"></span></span>
          <span class="button erase" title="Borrar todo"><span class="icon-delete"></span></span>
        </div>
      </div>
    `;
  }

  modal() {
    return document.querySelector(`.${this.name_}Modal`);
  }

  // Se repintan las celdas en lugar de rearmar el modal: rearmarlo cortaría el
  // arrastre en curso y perdería el drawer abierto.
  paintGrid() {
    const leds = this.leds();
    const modal = this.modal();
    if (!modal) return;
    modal.querySelectorAll('.matrix-grid .led').forEach((cell) => {
      cell.classList.toggle('led-on', !!leds[Number(cell.dataset.index)]);
    });
  }

  toggleLed(index, on) {
    const leds = { ...this.leds() };
    leds[index] = on;
    this.setLeds(leds);
  }

  disposeDrawerEvents() {
    this.drawerEvents_.forEach((event) => Blockly.browserEvents.unbind(event));
    this.drawerEvents_ = [];
  }

  addDrawerEvent(node, name, func) {
    this.drawerEvents_.push(Blockly.browserEvents.conditionalBind(node, name, this, func));
  }

  paintDrawer() {
    const modal = this.modal();
    if (!modal) return;

    this.disposeDrawerEvents();
    const viewport = modal.querySelector('.drawer-viewport');
    viewport.innerHTML = this.renderDrawer();
    // El viewport no se recrea y conservaría el scroll de la categoría anterior.
    viewport.scrollLeft = 0;
    modal.querySelector('.sidebar-panel').classList.toggle('open', !!this.openDrawer_);
    modal.querySelectorAll('.sidebar-buttons .picker').forEach((picker) => {
      picker.classList.toggle('selected', picker.dataset.drawer === this.openDrawer_);
    });

    modal.querySelectorAll('.drawer-viewport .preset').forEach((preset) => {
      this.addDrawerEvent(preset, 'click', () => {
        this.setLeds(presetToLeds(PRESETS[this.openDrawer_][preset.dataset.preset]));
      });
    });
  }

  addCustomModalEvents() {
    const modal = this.modal();
    if (!modal) return;

    // El primer click define si se prende o se apaga, y el arrastre repite esa acción.
    modal.querySelectorAll('.matrix-grid .led').forEach((cell) => {
      const index = Number(cell.dataset.index);

      this.addEvent_(cell, 'mousedown', this, (event) => {
        event.preventDefault();
        this.painting_ = !cell.classList.contains('led-on');
        this.toggleLed(index, this.painting_);
      });

      this.addEvent_(cell, 'mouseover', this, (event) => {
        if (event.buttons !== 1) return;
        this.toggleLed(index, this.painting_);
      });
    });

    modal.querySelectorAll('.sidebar-buttons .picker').forEach((picker) => {
      this.addEvent_(picker, 'click', this, () => {
        const { drawer } = picker.dataset;
        this.openDrawer_ = (this.openDrawer_ === drawer) ? null : drawer;
        this.paintDrawer();
      });
    });

    // Cada flecha corre tres miniaturas, lo que prod muestra por vista.
    const viewport = modal.querySelector('.drawer-viewport');
    const step = 3 * (PRESET_WIDTH + PRESET_GAP);
    this.addEvent_(modal.querySelector('.drawer-arrow.prev'), 'click', this, () => {
      viewport.scrollBy({ left: -step, behavior: 'smooth' });
    });
    this.addEvent_(modal.querySelector('.drawer-arrow.next'), 'click', this, () => {
      viewport.scrollBy({ left: step, behavior: 'smooth' });
    });

    const ruler = modal.querySelector('.button.ruler');
    this.addEvent_(ruler, 'click', this, () => {
      this.rulerOn_ = !this.rulerOn_;
      ruler.classList.toggle('ruler-on', this.rulerOn_);
      modal.querySelector('.matrix-grid').classList.toggle('ruler-on', this.rulerOn_);
    });

    const erase = modal.querySelector('.button.erase');
    this.addEvent_(erase, 'click', this, () => this.setLeds(emptyLeds()));

    const close = modal.querySelector('.matrix-close');
    this.addEvent_(close, 'click', this, () => {
      this.updateWorkspace();
      this.closeModal();
    });

    this.paintDrawer();
  }

  disposeEvents() {
    this.disposeDrawerEvents();
    super.disposeEvents();
  }
}
